export const holidaysKeys = {
  all: ['holidays'] as const,
  list: (params: { clientId?: string; fromDate?: string; toDate?: string }) =>
    [...holidaysKeys.all, 'list', params] as const,
};
